import { View } from "react-native";
const NOOP = () => {};
export const KeyboardController = {
  setDefaultMode: NOOP,
  setInputMode: NOOP,
  dismiss: NOOP,
  setFocusTo: NOOP,
  addListener: NOOP,
  removeListeners: NOOP
};
export const KeyboardEvents = {
  addListener: () => ({
    remove: NOOP
  })
};
/**
 * This API is not documented, it's for internal usage only (for now), and is a subject to potential breaking changes in future.
 * Use it with cautious.
 */
export const FocusedInputEvents = {
  addListener: () => ({
    remove: NOOP
  })
};
export const WindowDimensionsEvents = {
  addListener: () => ({
    remove: NOOP
  })
};
export const KeyboardControllerView = View;
export const KeyboardGestureArea = View;
//# sourceMappingURL=bindings.js.map